var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication / Mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.53174 6.7793L10.6394 11.3916L10.6414 11.3933C11.3196 11.8906 11.6589 12.1394 12.0305 12.2355C12.359 12.3205 12.7042 12.3205 13.0327 12.2355C13.4047 12.1393 13.7449 11.8898 14.4243 11.3916C14.4243 11.3916 18.3418 8.38524 20.5317 6.7793M3.53174 16.5795V8.97949C3.53174 7.85939 3.53174 7.29892 3.74973 6.87109C3.94147 6.49477 4.24721 6.18903 4.62354 5.99728C5.05136 5.7793 5.61183 5.7793 6.73193 5.7793H18.3319C19.452 5.7793 20.0113 5.7793 20.4391 5.99728C20.8155 6.18903 21.1222 6.49477 21.314 6.87109C21.5317 7.2985 21.5317 7.85829 21.5317 8.97621V16.5829C21.5317 17.7008 21.5317 18.2598 21.314 18.6872C21.1222 19.0635 20.8155 19.3698 20.4391 19.5615C20.0117 19.7793 19.4527 19.7793 18.3348 19.7793H6.72865C5.61073 19.7793 5.05094 19.7793 4.62354 19.5615C4.24721 19.3698 3.94147 19.0635 3.74973 18.6872C3.53174 18.2594 3.53174 17.6996 3.53174 16.5795Z",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMail);
export default __webpack_public_path__ + "static/media/contact_mail.020b78b7955287993072e96dd491b87d.svg";
export { ForwardRef as ReactComponent };